import { Box } from '@chakra-ui/react';
import ChartEmptyState from '@/components/ChartEmptyState';
import { AvgTimeToAcceptanceOrRejectionByOwnerResponse } from '@/types/api';
import * as Styles from './AvgTimeInDaysByOwner.styles';
import BarChartAvatar from '../../charts/BarChartAvatar/BarChartAvatar.component';
import ChartHeader from '../ChartHeader';
import Loading from '../general/Loading';

export type AvgTimeInDaysByOwnerProps = {
  data: AvgTimeToAcceptanceOrRejectionByOwnerResponse[];
  isLoading: boolean;
};

const AvgTimeInDaysByOwnerComponent = ({
  data,
  isLoading,
}: AvgTimeInDaysByOwnerProps): JSX.Element => {
  return (
    <Styles.CustomChartCard>
      <>
        <ChartHeader
          onSelectFilter={() => {}}
          filterOptions={[]}
          title="Average Time to Acceptance or Rejection grouped by Owner in Days"
          tooltipMessage="This chart displays the average number of days that both Trio and our partners take to accept or reject a candidate grouped by their owners."
        />
        <div>
          {isLoading && (
            <Box h={200} display="flex">
              <Loading />
            </Box>
          )}
          {!isLoading && !data.length && (
            <ChartEmptyState h={200} title="Ops, we don't have data." subTitle="No results found" />
          )}
          {!isLoading &&
            !!data.length &&
            data.map((item: any) => (
              <BarChartAvatar
                key={item.owner}
                firstBarWidth={item.chart.trioPercentage}
                secondBarWidth={item.chart.partnersPercentage}
                backgroundColorFirst="#043EAF"
                backgroundColorSecond="#A8BFF2"
                label={item.owner.split(' ')[0]}
                firstBarValue={item.chart.trio}
                secondBarValue={item.chart.partners}
                firstName={item?.owner?.split(' ')[0]}
                lastName={item?.owner?.split(' ')[1]}
              />
            ))}
        </div>

        {!isLoading && !!data.length && <Styles.Divider />}

        {!isLoading && !!data.length && (
          <Styles.Legend>
            <Styles.LegendItem>
              <Styles.Square isTrio />
              <Styles.LegendLabel>by Trio</Styles.LegendLabel>
            </Styles.LegendItem>
            <Styles.LegendItem>
              <Styles.Square />
              <Styles.LegendLabel>by Partners</Styles.LegendLabel>
            </Styles.LegendItem>
          </Styles.Legend>
        )}
      </>
    </Styles.CustomChartCard>
  );
};

export default AvgTimeInDaysByOwnerComponent;
